import tmhRequest from '@/config/tmhRequest'

export default {
  searchListRole: function ( data) {
    return tmhRequest({
      url: '/system/tmh/role/searchlistrole',
      method: 'post',
      params: data,
    })
  },
  searchRoleDetail: function ( data) {
    return tmhRequest({
      url: '/system/tmh/role/searchroledetail',
      method: 'post',
      params: data,
    })
  },
  addRoleAndModule: function (data) {
    return tmhRequest({
      url: '/system/tmh/role/addroleandmodule',
      method: 'post',
      data: data
    })
  },

  editRoleAndModule: function (data) {
    return tmhRequest({
      url: '/system/tmh/role/editroleandmodule',
      method: 'post',
      data: data
    })
  },

  deleteRole: function (listRole) {
    return tmhRequest({
      url: '/system/tmh/role/deleterole',
      method: 'post',
      data: {        
        listrole:listRole,
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/tmh/system/role.js